var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSendIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 175,
    viewBox: "0 0 211 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2723"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon 7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5 0L161 64H4L82.5 0Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 0L161 64H4L82.5 0Z",
    fill: "#9EBCFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 6301"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 64,
    width: 157,
    height: 82,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 64,
    width: 157,
    height: 82,
    fill: "#9EBCFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 6300",
    filter: "url(#filter0_d_5170_6176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 9,
    width: 110,
    height: 131,
    fill: "url(#paint0_linear_5170_6176)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 5113",
    filter: "url(#filter1_d_5170_6176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 146V64L56.5 104L4 146Z",
    fill: "url(#paint1_linear_5170_6176)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 5114",
    filter: "url(#filter2_d_5170_6176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161 146V64L109 104L161 146Z",
    fill: "url(#paint2_linear_5170_6176)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon 6",
    filter: "url(#filter3_d_5170_6176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.4451 86.1214C80.3881 83.722 84.6124 83.722 87.5554 86.1214L161 146H4L77.4451 86.1214Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4451 86.1214C80.3881 83.722 84.6124 83.722 87.5554 86.1214L161 146H4L77.4451 86.1214Z",
    fill: "url(#paint3_linear_5170_6176)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 2618"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 131,
    y: 93,
    width: 80,
    height: 82
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_5170_6176_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 247",
    filter: "url(#filter4_d_5170_6176)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 133,
    r: 36,
    fill: "url(#paint4_linear_5170_6176)",
    fillOpacity: 0.71,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5066",
    d: "M155 133.277L167.21 146L187 123",
    stroke: "#4C95FF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5170_6176",
    x: 24,
    y: 7,
    width: 118,
    height: 139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5170_6176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5170_6176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5170_6176",
    x: 0,
    y: 60,
    width: 60.5,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5170_6176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5170_6176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5170_6176",
    x: 105,
    y: 60,
    width: 60,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5170_6176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5170_6176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5170_6176",
    x: 0,
    y: 80.3218,
    width: 165,
    height: 69.6782,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5170_6176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5170_6176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5170_6176",
    x: 131,
    y: 93,
    width: 80,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5170_6176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5170_6176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5170_6176_clip_path",
    transform: "translate(-131 -93)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 133,
    r: 36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5170_6176",
    x1: 83,
    y1: 9,
    x2: 83,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5170_6176",
    x1: 30.5,
    y1: 64,
    x2: 30.5,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5170_6176",
    x1: 135,
    y1: 64,
    x2: 135,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5170_6176",
    x1: 82.5,
    y1: 82,
    x2: 82.5,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5170_6176",
    x1: 135,
    y1: 127,
    x2: 211.5,
    y2: 150.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSendIllustration);
export default __webpack_public_path__ + "static/media/emailSendIllustration.f679afee5bc6f64bf7fdc0bfd8f713ae.svg";
export { ForwardRef as ReactComponent };